export enum LocalStorageKeys {
    SENT_SMS_PENDING = 'sent-sms-pending',
    COUNTRY = 'country',
    LANGUAGE = 'language',
}
